export default "__VITE_ASSET__BDZjQFgc__"